import { createSlice } from '@reduxjs/toolkit';
import {
    fetchCommentsRequest, fetchCommentsSuccess, fetchCommentsFailure,
    createCommentRequest, createCommentSuccess, createCommentFailure,
    deleteCommentRequest, deleteCommentSuccess, deleteCommentFailure
} from '../actions/commentActions';
import { CommentItem } from '../../types/commentTypes';

interface CommentState {
    items: CommentItem[];
    loading: boolean;
    error: string | null;
}

const initialState: CommentState = {
    items: [],
    loading: false,
    error: null,
};

const commentSlice = createSlice({
    name: 'comment',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCommentsRequest, (state) => {
                state.loading = true;
            })
            .addCase(fetchCommentsSuccess, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(fetchCommentsFailure, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createCommentRequest, (state) => {
                state.loading = true;
            })
            .addCase(createCommentSuccess, (state, action) => {
                state.loading = false;
                state.items.push(action.payload);
            })
            .addCase(createCommentFailure, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteCommentRequest, (state) => {
                state.loading = true;
            })
            .addCase(deleteCommentSuccess, (state, action) => {
                state.loading = false;
                state.items = state.items.filter(comment => comment.id !== action.payload);
            })
            .addCase(deleteCommentFailure, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default commentSlice.reducer;
